import { moduleNames } from '../../constants';
import { appNames, isAgentMetrics } from '../../constants/app';

export const getProductFlags = userProducts => {
    const values = userProducts || [];
    return {
        has_proficiency_metrics: values.includes(moduleNames.proficiencyMetrics),
        has_market_share: values.includes(moduleNames.marketShare),
        has_market_dynamics: values.includes(moduleNames.marketDynamics),
    };
};

export const getPendoDataLayers = ({ tokenInfo, selectedAccount, isLegacyUser, runningApp, productFlags, ownerId }) => {
    // This function creates anonymous visitor IDs in Pendo unless you change the visitor id field to use your app's values
    // This function uses the placeholder 'LEGACY-USER' or 'AGENT-METRICS-USER' values for account ID unless you change the account id field to use your app's values
    // Call initializePendo function from App.js and use this function to get your Pendo Data Layers in your authentication promise handler or callback when your visitor and account id values are available
    // Please use Strings, Numbers, or Bools for value types.
    const userWithoutAccountId = isLegacyUser ? 'LEGACY-USER' : (isAgentMetrics || runningApp === appNames.XAM) ? 'AGENT-METRICS-USER' : null;
    const hasAssociatedAccount = !isAgentMetrics && !isLegacyUser && runningApp !== appNames.XAM;

    return {
        visitor: {
            ...productFlags,
            id: tokenInfo.email, //'VISITOR-UNIQUE-ID'   // Required if user is logged in, default creates anonymous ID
            email: tokenInfo.email, // Recommended if using Pendo Feedback, or NPS Email
            full_name: tokenInfo.name, // Recommended if using Pendo Feedback
            ...(selectedAccount ? { accountId: selectedAccount.id } : {}),
            ...(selectedAccount ? { accountName: selectedAccount.name } : {}),
            legacy: !!isLegacyUser,
            // role:         // Optional

            // You can add any additional visitor level key-values here,
            // as long as it's not one of the above reserved names.
            ...(tokenInfo?.auth_time && { auth_time: tokenInfo.auth_time }),
            sub: ownerId,
            session_state: tokenInfo.session_state,
            roles: tokenInfo?.resource_access?.account.roles,
            scope: tokenInfo.scope,
            name: tokenInfo.name,
            preferred_username: tokenInfo.preferred_username,
            given_name: tokenInfo.given_name,
            family_name: tokenInfo.family_name,
            app: runningApp
        },
        account: {
            id: hasAssociatedAccount ? selectedAccount?.id : userWithoutAccountId, // Required if using Pendo Feedback, we use 'LEGACY-USER' or 'AGENT-METRICS-USER' values for users without associated account (Legacy and Agent Metrics users)
            ...((hasAssociatedAccount && selectedAccount) ? { name: selectedAccount?.name } : {})
            // is_paying:    // Recommended if using Pendo Feedback
            // monthly_value:// Recommended if using Pendo Feedback
            // planLevel:    // Optional
            // planPrice:    // Optional
            // creationDate: // Optional

            // You can add any additional account level key-values here,
            // as long as it's not one of the above reserved names.
        }
    };
};
